export enum VerificationMethodEnum {
  EMAIL = "email",
  PHONE = "phone",
}
